// @ts-nocheck

import * as Apollo from "@apollo/client";

import gql from "graphql-tag";
import * as APITypes from "../../apiTypes";
import {
  ReviewAggregateResponseFragmentDoc,
  ReviewConnectionFragmentDoc,
  ReviewFragmentDoc,
} from "./fragments.generated";

const defaultOptions = {} as const;
export type GetReviewQueryVariables = APITypes.Exact<{
  id: APITypes.Scalars["ID"]["input"];
}>;

export type GetReviewQuery = {
  review: {
    comment: string;
    customerId: string;
    customerName: string;
    customerProfilePhoto?: string | null;
    id: string;
    rating: number;
    reservationCity: string;
    reservationStartedAt: string;
    title: string;
    postedAt: string;
  };
};

export type ListReviewsQueryVariables = APITypes.Exact<{
  filter: APITypes.ReviewFilter;
  paging?: APITypes.InputMaybe<APITypes.CursorPaging>;
  sorting: Array<APITypes.ReviewSort> | APITypes.ReviewSort;
}>;

export type ListReviewsQuery = {
  reviews: {
    edges: Array<{
      cursor: any;
      node: {
        comment: string;
        customerId: string;
        customerName: string;
        customerProfilePhoto?: string | null;
        id: string;
        rating: number;
        reservationCity: string;
        reservationStartedAt: string;
        title: string;
        postedAt: string;
      };
    }>;
    pageInfo: {
      endCursor?: any | null;
      hasNextPage?: boolean | null;
      hasPreviousPage?: boolean | null;
      startCursor?: any | null;
    };
  };
};

export type ListHomepageReviewsQueryVariables = APITypes.Exact<{ [key: string]: never }>;

export type ListHomepageReviewsQuery = {
  listReviewsForHomepage: Array<{
    comment: string;
    customerId: string;
    customerName: string;
    customerProfilePhoto?: string | null;
    id: string;
    rating: number;
    reservationCity: string;
    reservationStartedAt: string;
    title: string;
    postedAt: string;
  }>;
};

export type GetReviewAggregateQueryVariables = APITypes.Exact<{
  filter?: APITypes.InputMaybe<APITypes.ReviewAggregateFilter>;
}>;

export type GetReviewAggregateQuery = {
  reviewAggregate: Array<{
    avg?: { rating?: number | null } | null;
    sum?: { rating?: number | null } | null;
  }>;
};

export type GetAverageReviewsForBundleQueryVariables = APITypes.Exact<{
  bundleId: APITypes.Scalars["String"]["input"];
}>;

export type GetAverageReviewsForBundleQuery = {
  getAverageReviewsForBundle: { average: number; total: number };
};

export type GetAverageReviewsForWorkerQueryVariables = APITypes.Exact<{
  workerId: APITypes.Scalars["String"]["input"];
}>;

export type GetAverageReviewsForWorkerQuery = {
  getAverageReviewsForWorker: { average: number; completedCleanings: number; total: number };
};

export type GetAverageReviewsForApplicationQueryVariables = APITypes.Exact<{
  [key: string]: never;
}>;

export type GetAverageReviewsForApplicationQuery = {
  getAverageReviewsForApplication: {
    average: number;
    total: number;
    oneStarCount: number;
    twoStarCount: number;
    threeStarCount: number;
    fourStarCount: number;
    fiveStarCount: number;
  };
};

export type CreateReviewMutationVariables = APITypes.Exact<{
  review: APITypes.ReviewPayload;
}>;

export type CreateReviewMutation = {
  createReview: {
    comment: string;
    customerId: string;
    customerName: string;
    customerProfilePhoto?: string | null;
    id: string;
    rating: number;
    reservationCity: string;
    reservationStartedAt: string;
    title: string;
    postedAt: string;
  };
};

export const GetReviewDocument = gql`
    query GetReview($id: ID!) {
  review(id: $id) {
    ...Review
  }
}
    ${ReviewFragmentDoc}`;

/**
 * __useGetReviewQuery__
 *
 * To run a query within a React component, call `useGetReviewQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetReviewQuery(
  baseOptions: Apollo.QueryHookOptions<GetReviewQuery, GetReviewQueryVariables> &
    ({ variables: GetReviewQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewQuery, GetReviewQueryVariables>(GetReviewDocument, options);
}
export function useGetReviewLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewQuery, GetReviewQueryVariables>(GetReviewDocument, options);
}
export function useGetReviewSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReviewQuery, GetReviewQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReviewQuery, GetReviewQueryVariables>(
    GetReviewDocument,
    options,
  );
}
export type GetReviewQueryHookResult = ReturnType<typeof useGetReviewQuery>;
export type GetReviewLazyQueryHookResult = ReturnType<typeof useGetReviewLazyQuery>;
export type GetReviewSuspenseQueryHookResult = ReturnType<typeof useGetReviewSuspenseQuery>;
export type GetReviewQueryResult = Apollo.QueryResult<GetReviewQuery, GetReviewQueryVariables>;
export const ListReviewsDocument = gql`
    query ListReviews($filter: ReviewFilter!, $paging: CursorPaging, $sorting: [ReviewSort!]!) {
  reviews(filter: $filter, paging: $paging, sorting: $sorting) {
    ...ReviewConnection
  }
}
    ${ReviewConnectionFragmentDoc}`;

/**
 * __useListReviewsQuery__
 *
 * To run a query within a React component, call `useListReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListReviewsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      paging: // value for 'paging'
 *      sorting: // value for 'sorting'
 *   },
 * });
 */
export function useListReviewsQuery(
  baseOptions: Apollo.QueryHookOptions<ListReviewsQuery, ListReviewsQueryVariables> &
    ({ variables: ListReviewsQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListReviewsQuery, ListReviewsQueryVariables>(ListReviewsDocument, options);
}
export function useListReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<ListReviewsQuery, ListReviewsQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListReviewsQuery, ListReviewsQueryVariables>(
    ListReviewsDocument,
    options,
  );
}
export function useListReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListReviewsQuery, ListReviewsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListReviewsQuery, ListReviewsQueryVariables>(
    ListReviewsDocument,
    options,
  );
}
export type ListReviewsQueryHookResult = ReturnType<typeof useListReviewsQuery>;
export type ListReviewsLazyQueryHookResult = ReturnType<typeof useListReviewsLazyQuery>;
export type ListReviewsSuspenseQueryHookResult = ReturnType<typeof useListReviewsSuspenseQuery>;
export type ListReviewsQueryResult = Apollo.QueryResult<
  ListReviewsQuery,
  ListReviewsQueryVariables
>;
export const ListHomepageReviewsDocument = gql`
    query ListHomepageReviews {
  listReviewsForHomepage {
    ...Review
  }
}
    ${ReviewFragmentDoc}`;

/**
 * __useListHomepageReviewsQuery__
 *
 * To run a query within a React component, call `useListHomepageReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useListHomepageReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useListHomepageReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useListHomepageReviewsQuery(
  baseOptions?: Apollo.QueryHookOptions<
    ListHomepageReviewsQuery,
    ListHomepageReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ListHomepageReviewsQuery, ListHomepageReviewsQueryVariables>(
    ListHomepageReviewsDocument,
    options,
  );
}
export function useListHomepageReviewsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ListHomepageReviewsQuery,
    ListHomepageReviewsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ListHomepageReviewsQuery, ListHomepageReviewsQueryVariables>(
    ListHomepageReviewsDocument,
    options,
  );
}
export function useListHomepageReviewsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<ListHomepageReviewsQuery, ListHomepageReviewsQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<ListHomepageReviewsQuery, ListHomepageReviewsQueryVariables>(
    ListHomepageReviewsDocument,
    options,
  );
}
export type ListHomepageReviewsQueryHookResult = ReturnType<typeof useListHomepageReviewsQuery>;
export type ListHomepageReviewsLazyQueryHookResult = ReturnType<
  typeof useListHomepageReviewsLazyQuery
>;
export type ListHomepageReviewsSuspenseQueryHookResult = ReturnType<
  typeof useListHomepageReviewsSuspenseQuery
>;
export type ListHomepageReviewsQueryResult = Apollo.QueryResult<
  ListHomepageReviewsQuery,
  ListHomepageReviewsQueryVariables
>;
export const GetReviewAggregateDocument = gql`
    query GetReviewAggregate($filter: ReviewAggregateFilter) {
  reviewAggregate(filter: $filter) {
    ...ReviewAggregateResponse
  }
}
    ${ReviewAggregateResponseFragmentDoc}`;

/**
 * __useGetReviewAggregateQuery__
 *
 * To run a query within a React component, call `useGetReviewAggregateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReviewAggregateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReviewAggregateQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetReviewAggregateQuery(
  baseOptions?: Apollo.QueryHookOptions<GetReviewAggregateQuery, GetReviewAggregateQueryVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetReviewAggregateQuery, GetReviewAggregateQueryVariables>(
    GetReviewAggregateDocument,
    options,
  );
}
export function useGetReviewAggregateLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetReviewAggregateQuery,
    GetReviewAggregateQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetReviewAggregateQuery, GetReviewAggregateQueryVariables>(
    GetReviewAggregateDocument,
    options,
  );
}
export function useGetReviewAggregateSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<GetReviewAggregateQuery, GetReviewAggregateQueryVariables>,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<GetReviewAggregateQuery, GetReviewAggregateQueryVariables>(
    GetReviewAggregateDocument,
    options,
  );
}
export type GetReviewAggregateQueryHookResult = ReturnType<typeof useGetReviewAggregateQuery>;
export type GetReviewAggregateLazyQueryHookResult = ReturnType<
  typeof useGetReviewAggregateLazyQuery
>;
export type GetReviewAggregateSuspenseQueryHookResult = ReturnType<
  typeof useGetReviewAggregateSuspenseQuery
>;
export type GetReviewAggregateQueryResult = Apollo.QueryResult<
  GetReviewAggregateQuery,
  GetReviewAggregateQueryVariables
>;
export const GetAverageReviewsForBundleDocument = gql`
    query GetAverageReviewsForBundle($bundleId: String!) {
  getAverageReviewsForBundle(bundleId: $bundleId) {
    average
    total
  }
}
    `;

/**
 * __useGetAverageReviewsForBundleQuery__
 *
 * To run a query within a React component, call `useGetAverageReviewsForBundleQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageReviewsForBundleQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageReviewsForBundleQuery({
 *   variables: {
 *      bundleId: // value for 'bundleId'
 *   },
 * });
 */
export function useGetAverageReviewsForBundleQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAverageReviewsForBundleQuery,
    GetAverageReviewsForBundleQueryVariables
  > &
    ({ variables: GetAverageReviewsForBundleQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAverageReviewsForBundleQuery, GetAverageReviewsForBundleQueryVariables>(
    GetAverageReviewsForBundleDocument,
    options,
  );
}
export function useGetAverageReviewsForBundleLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAverageReviewsForBundleQuery,
    GetAverageReviewsForBundleQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAverageReviewsForBundleQuery,
    GetAverageReviewsForBundleQueryVariables
  >(GetAverageReviewsForBundleDocument, options);
}
export function useGetAverageReviewsForBundleSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAverageReviewsForBundleQuery,
        GetAverageReviewsForBundleQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAverageReviewsForBundleQuery,
    GetAverageReviewsForBundleQueryVariables
  >(GetAverageReviewsForBundleDocument, options);
}
export type GetAverageReviewsForBundleQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForBundleQuery
>;
export type GetAverageReviewsForBundleLazyQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForBundleLazyQuery
>;
export type GetAverageReviewsForBundleSuspenseQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForBundleSuspenseQuery
>;
export type GetAverageReviewsForBundleQueryResult = Apollo.QueryResult<
  GetAverageReviewsForBundleQuery,
  GetAverageReviewsForBundleQueryVariables
>;
export const GetAverageReviewsForWorkerDocument = gql`
    query GetAverageReviewsForWorker($workerId: String!) {
  getAverageReviewsForWorker(workerId: $workerId) {
    average
    completedCleanings
    total
  }
}
    `;

/**
 * __useGetAverageReviewsForWorkerQuery__
 *
 * To run a query within a React component, call `useGetAverageReviewsForWorkerQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageReviewsForWorkerQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageReviewsForWorkerQuery({
 *   variables: {
 *      workerId: // value for 'workerId'
 *   },
 * });
 */
export function useGetAverageReviewsForWorkerQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAverageReviewsForWorkerQuery,
    GetAverageReviewsForWorkerQueryVariables
  > &
    ({ variables: GetAverageReviewsForWorkerQueryVariables; skip?: boolean } | { skip: boolean }),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetAverageReviewsForWorkerQuery, GetAverageReviewsForWorkerQueryVariables>(
    GetAverageReviewsForWorkerDocument,
    options,
  );
}
export function useGetAverageReviewsForWorkerLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAverageReviewsForWorkerQuery,
    GetAverageReviewsForWorkerQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAverageReviewsForWorkerQuery,
    GetAverageReviewsForWorkerQueryVariables
  >(GetAverageReviewsForWorkerDocument, options);
}
export function useGetAverageReviewsForWorkerSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAverageReviewsForWorkerQuery,
        GetAverageReviewsForWorkerQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAverageReviewsForWorkerQuery,
    GetAverageReviewsForWorkerQueryVariables
  >(GetAverageReviewsForWorkerDocument, options);
}
export type GetAverageReviewsForWorkerQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForWorkerQuery
>;
export type GetAverageReviewsForWorkerLazyQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForWorkerLazyQuery
>;
export type GetAverageReviewsForWorkerSuspenseQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForWorkerSuspenseQuery
>;
export type GetAverageReviewsForWorkerQueryResult = Apollo.QueryResult<
  GetAverageReviewsForWorkerQuery,
  GetAverageReviewsForWorkerQueryVariables
>;
export const GetAverageReviewsForApplicationDocument = gql`
    query GetAverageReviewsForApplication {
  getAverageReviewsForApplication {
    average
    total
    oneStarCount
    twoStarCount
    threeStarCount
    fourStarCount
    fiveStarCount
  }
}
    `;

/**
 * __useGetAverageReviewsForApplicationQuery__
 *
 * To run a query within a React component, call `useGetAverageReviewsForApplicationQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAverageReviewsForApplicationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAverageReviewsForApplicationQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAverageReviewsForApplicationQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetAverageReviewsForApplicationQuery,
    GetAverageReviewsForApplicationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAverageReviewsForApplicationQuery,
    GetAverageReviewsForApplicationQueryVariables
  >(GetAverageReviewsForApplicationDocument, options);
}
export function useGetAverageReviewsForApplicationLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAverageReviewsForApplicationQuery,
    GetAverageReviewsForApplicationQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAverageReviewsForApplicationQuery,
    GetAverageReviewsForApplicationQueryVariables
  >(GetAverageReviewsForApplicationDocument, options);
}
export function useGetAverageReviewsForApplicationSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAverageReviewsForApplicationQuery,
        GetAverageReviewsForApplicationQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAverageReviewsForApplicationQuery,
    GetAverageReviewsForApplicationQueryVariables
  >(GetAverageReviewsForApplicationDocument, options);
}
export type GetAverageReviewsForApplicationQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForApplicationQuery
>;
export type GetAverageReviewsForApplicationLazyQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForApplicationLazyQuery
>;
export type GetAverageReviewsForApplicationSuspenseQueryHookResult = ReturnType<
  typeof useGetAverageReviewsForApplicationSuspenseQuery
>;
export type GetAverageReviewsForApplicationQueryResult = Apollo.QueryResult<
  GetAverageReviewsForApplicationQuery,
  GetAverageReviewsForApplicationQueryVariables
>;
export const CreateReviewDocument = gql`
    mutation CreateReview($review: ReviewPayload!) {
  createReview(review: $review) {
    ...Review
  }
}
    ${ReviewFragmentDoc}`;
export type CreateReviewMutationFn = Apollo.MutationFunction<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;

/**
 * __useCreateReviewMutation__
 *
 * To run a mutation, you first call `useCreateReviewMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateReviewMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createReviewMutation, { data, loading, error }] = useCreateReviewMutation({
 *   variables: {
 *      review: // value for 'review'
 *   },
 * });
 */
export function useCreateReviewMutation(
  baseOptions?: Apollo.MutationHookOptions<CreateReviewMutation, CreateReviewMutationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateReviewMutation, CreateReviewMutationVariables>(
    CreateReviewDocument,
    options,
  );
}
export type CreateReviewMutationHookResult = ReturnType<typeof useCreateReviewMutation>;
export type CreateReviewMutationResult = Apollo.MutationResult<CreateReviewMutation>;
export type CreateReviewMutationOptions = Apollo.BaseMutationOptions<
  CreateReviewMutation,
  CreateReviewMutationVariables
>;
